import React from 'react';

import './poweredByPushpay.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { PushpayLogo } from '../../assets/svg/PushpayLogo';

type PoweredByPushpayProps = {
	className?: string;
};

export function PoweredByPushpay({ className }: PoweredByPushpayProps) {
	const { t } = useTranslation();

	return (
		<a
			className={clsx('container', className)}
			href="https://pushpay.com/"
			rel="noopener noreferrer"
			target="_blank"
		>
			<span>{t('poweredBy')}:</span>
			<PushpayLogo className="pushpayLogo" width="70" />
		</a>
	);
}
